import React, { useContext, useEffect, useState } from "react"
import moment from "moment-timezone"
import filterEvents from "./filterEvents"
import { futureEvent, pastEvent } from "./utils"
import PropTypes from "prop-types"
import { SpaceProfileContext } from "../../context"

const TimeSelector = ({ updateTimepicker, calendar = {}, events }) => {
  const [busyTimes, setBusyTimes] = useState([])

  const {
    commonData: { contextTime, availableContextTimes, contextDate },
    actions: { setContextTimes, setBookTourStep },
  } = useContext(SpaceProfileContext)

  useEffect(() => {
    setBusyTimes(filterEvents(events, calendar))
  }, [])

  const { duration, buffer, available_times, notice, time_zone } =
    calendar || {}

  useEffect(() => {
    const day = moment(contextDate).day()
    const selectedDate = moment(contextDate).format("YYYY-MM-DD")
    if (!calendar || !contextDate || day === 0 || day === 6) {
      setContextTimes([])
      return
    }

    const activeTime = available_times
      ? available_times.find(
          (time) => time.day === moment(contextDate).format("dddd")
        )
      : []

    const noticeEndString = moment()
      .tz(time_zone)
      .add(notice, "hours")
      .add(30 - moment().tz(time_zone).format("mm"), "minutes")
      .format("LLL")

    const noticeEnd = moment(noticeEndString)

    let startTime =
      contextDate && activeTime && activeTime.from
        ? moment(selectedDate + " " + activeTime.from, "YYYY-MM-DD HH:mm a")
        : moment(selectedDate + " 9:00 am", "YYYY-MM-DD HH:mm a")

    const endTime =
      contextDate && activeTime && activeTime.to
        ? moment(selectedDate + " " + activeTime.to, "YYYY-MM-DD h:mm a")
        : moment(selectedDate + " 4:00 pm", "YYYY-MM-DD h:mm a")

    if (startTime.isBefore(noticeEnd) && noticeEnd.isBefore(endTime)) {
      startTime = noticeEnd
    } else if (startTime.isBefore(noticeEnd) && noticeEnd.isAfter(endTime)) {
      startTime = endTime
    }

    let currentTime = startTime
    let tempTimeSlots = []
    while (currentTime.isBefore(endTime)) {
      const existingEvents = busyTimes.find(
        (event) => event.date === selectedDate
      )

      if (existingEvents && existingEvents.events.length > 0) {
        let conflicts = false
        for (let j = 0; j < existingEvents.events.length; j++) {
          const currentEvent = existingEvents.events[j]
          if (currentEvent.isAllDay) {
            currentTime = endTime
          } else {
            const eventStart = moment(
              currentEvent.start ? currentEvent.start : null
            ).subtract(buffer, "minutes")
            const eventEnd = moment(new Date(currentEvent.end)).add(
              buffer,
              "minutes"
            )

            if (
              pastEvent(eventStart, eventEnd, currentTime) ||
              futureEvent(eventStart, eventEnd, currentTime, duration)
            ) {
              // pass
            } else {
              conflicts = true
            }
          }
        }
        if (!conflicts) {
          tempTimeSlots.push(currentTime.format("h:mm a"))
        }
        currentTime.add(duration, "minutes")
      } else {
        // if no existing events events
        tempTimeSlots.push(currentTime.format("h:mm a"))
        currentTime.add(duration, "minutes")
      }

      setContextTimes(tempTimeSlots)
    }
  }, [contextDate, events, calendar, busyTimes])

  return (
    <>
      {availableContextTimes && availableContextTimes.length > 0 ? (
        <ul className="times">
          {availableContextTimes.map((t) => (
            <li
              key={t}
              onClick={() => updateTimepicker(t)}
              className={contextTime === t ? "active" : ""}
            >
              {t}
            </li>
          ))}
        </ul>
      ) : (
        <>
          <p>No timeslots available</p>
        </>
      )}
      <br />
      <br />
      <br />
      <button
        className="btn btn-link d-lg-none"
        onClick={() => setBookTourStep(1)}
      >
        Back
      </button>
    </>
  )
}

export default TimeSelector

TimeSelector.propTypes = {
  updateTimepicker: PropTypes.func,
  busy: PropTypes.array,
  calendar: PropTypes.object,
  events: PropTypes.array,
}
